var render = function(_h, _vm) {
  var _c = _vm._c
  return _c("li", { staticClass: "nav-header" }, [
    _vm._v(_vm._s(_vm.props.title))
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }